import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useContext } from 'react';
import { BlockContext as SubBlockContext } from '../utils/constructed-block/block-context';
import { sendAnalytic } from '../utils/send-event';
import { BlockContext } from '../contexts/block-context';
export var useAnalytics = function useAnalytics() {
  var _useContext = useContext(BlockContext),
    containerId = _useContext.containerId,
    containerIndex = _useContext.containerIndex;
  var _ref = useContext(SubBlockContext) || {},
    id = _ref.id;
  return useCallback(function (name, eventData) {
    sendAnalytic(name, _objectSpread(_objectSpread({}, eventData), {}, {
      containerId: containerId,
      containerIndex: containerIndex
    }, id && {
      blockId: id
    }));
  }, [containerId, containerIndex, id]);
};